import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import UserRoles from 'app/types/UserRoles';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectNewDesignEnabled } from 'app/store/pagesToolbar/pagesToolbar.selectors';
import { selectPagesInWorkspace } from 'app/store/page/page.selectors';
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Button, Tooltip } from '@mui/material';
// Dialogs
import ExportWorkspacePagesToPDFDialog from '@root/dialogs/ExportWorkspacePagesToPDF.dialog';
// i18next
import Icon from 'app/components/Icon';
import { IconButton } from 'app/components/Mui';

const ExportPagesToPDFButton = () => {
  const { t } = useTranslation();

  // Selectors
  const trialMode = useAppSelector(selectTrialMode);
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  // ToDO
  const myUser:any = useAppSelector(selectMyUser);
  const pages:any = useAppSelector(selectPagesInWorkspace);

  const [ open, setOpen ] = useState(false);
  const onToggleDialog = () => setOpen(!open);

  const isUserRoleAdminOrStaff = myUser?.role === UserRoles.Admin || myUser?.role === UserRoles.Staff;
  const hasPages = pages && pages.length > 0;

  if (
    trialMode ||
    !isUserRoleAdminOrStaff ||
    !hasPages
  ) return null;
  return (
    <Fragment>
      {newDesignEnabled ? (
        <Tooltip title={t('pages.workspace.exportPdfButton')}>
          <IconButton
            name="Export pages to pdf"
            onClick={onToggleDialog}
          ><Icon icon="save_alt" /> </IconButton>
        </Tooltip>
      ) : (
        <Button
          onClick={onToggleDialog}
          fullWidth
          variant="outlined"
          color="primary"
        >{t('pages.workspace.exportPdfButton')}</Button>
      )}
      {open ? (
        <ExportWorkspacePagesToPDFDialog
          open={open}
          onClose={onToggleDialog}
          pages={pages}
        />
      ) : null}
    </Fragment>
  )
}

export default ExportPagesToPDFButton;
